export default __webpack_public_path__ + "static/media/20.b9f13572.webp";